import type { ComponentProps, FC } from 'react';

export const PencilIcon: FC<ComponentProps<'svg'>> = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4142 6.99991L17 2.58569L4.09706 15.4887L3.02988 19.7574C2.94468 20.0981 3.04453 20.4586 3.29291 20.707C3.54129 20.9554 3.90178 21.0552 4.24256 20.97L8.51127 19.9029L21.4142 6.99991ZM5.37439 18.6255L5.90299 16.5112L17 5.41412L18.5858 6.99991L7.48877 18.0969L5.37439 18.6255ZM12 20.9999H20V18.9999H12V20.9999Z"
        fill="#0060AD"
      />
    </svg>
  );
};
